module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYBAMAAAAbsoCxAAAAJ1BMVEXV1dXNzc3MzMzOzs7Nzc3Q0NDNzc3////4+PjS0tLl5eXv7+/b29tmq9onAAAABnRSTlMC8s/HbBvoeTZ1AAAAY0lEQVQY02NgYDFMgwJhBwYGVrU0OEgKYGBKQwIKDG7I3BQGM2RuMoMYMjeRAUzNhPEh3PZlKNzyimMo3PLqaSjc8ipUbnkbPm4VHqMQFmE6A+FINC+geRDN+2iBgxZ0aAELAJ53gl2aysPbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/life_jk_home_film@2x.png
// module id = Ug74
// module chunks = 1